import React from "react";
import AccountVerification from "./AccountVerification";

const AccountVerificationWithQuery = props => (
  <AccountVerification title={"Verify your account"} {...props} />
);

export default AccountVerificationWithQuery;
